module.exports = __webpack_public_path__ + "static/img/mask.78857894.png";